module.exports = __webpack_public_path__ + "img/file.eb42bc36.svg";